module.exports = __webpack_public_path__ + "220c8d0b311b9a9dac16d9412a3779de.jpg";